export enum AmostrasExportacaoEventsEnum {
  Criadas = 'amostras-exportacao-cadastro',
}

export enum ClientesAmostraExportacaoEnum {
  AURUBIS = 'AURUBIS',
  GLENCORE = 'GLENCORE',
  OUTROS = 'OUTROS',
}
